<div *ngIf="total" class="Pagination">
    <div class="Pagination-buttons" data-cy="page-next">
        <pagination-controls maxSize="7" autoHide="false" nextLabel="{{'globalMiss/next' | lowercase | translate}}"
            previousLabel="{{'globalMiss/back' | lowercase | translate}}" (pageChange)="onPageChange($event)">
        </pagination-controls>
    </div>
</div>
